define('collections/calendar/session/exercise/cardio/phases',[
    'underscore',
    'backbone',
    'utils',
    'models/calendar/session/exercise/cardio/phase'
], function(
    // libs
    _, Backbone, U,
    // model
    MPhase
) {

    var CPhases = Backbone.Collection.extend({
        model: MPhase,


        onNumWeekChange: function(model, value, options) {
            this.each(function(phase) {
                phase.onNumWeekChange(model, value, options);
            });
        },
    });

    return CPhases;
});

